import axios from 'axios';

export const VoucherWaitingListApi = {
  loadWaitingList: filter =>
    axios.get(`api/public/info/kindergarten_voucher_waiting_list_child_po?filter=${filter}`)
};
